// extracted by mini-css-extract-plugin
module.exports = {"TextInput":"textInput_TextInput__1_C1f","inputBlock":"textInput_inputBlock__3PU0Z"};